export default __webpack_public_path__ + "static/media/heartbreak_icon_red.82760370.svg";